import React, { useState } from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import footerlogo from "../Assets/logowhite.png";
import { motion } from "framer-motion";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setStatus("Subscribing...");

    try {
      const response = await fetch(
        "https://newzealacademy.com/subscribeMailer.php",
        {
          method: "POST",
          body: new URLSearchParams({ email }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      const result = await response.json();
      setStatus(result.message);
      if (result.status === "success") setEmail("");
    } catch (error) {
      setStatus("Failed to subscribe. Try again later.");
    }
  };

  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      {/* Newsletter Section */}
      <motion.div
        className="newsletter"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        {/* <div>
          <h3>Subscribe to our newsletter</h3>
          <p>
            Stay updated with the latest trends, insights, and special offers
            delivered straight to your inbox.
          </p>
        </div> */}
        {/* <div className="newsletter-form">
          <form onSubmit={handleSubscribe}>
            <span style={{ display: "flex", gap: "10px" }}>
              <motion.input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                whileFocus={{ scale: 1.02 }}
              />
              <motion.button
                type="submit"
                whileHover={{ scale: 1.05, backgroundColor: "#ff6600" }}
                whileTap={{ scale: 0.95 }}
              >
                Subscribe
              </motion.button>
            </span>
          </form>
          {status && (
            <span>
              <small>{status}</small>
            </span>
          )}
          <span>
            <small>
              By subscribing you agree to our <a href="#">Privacy Policy</a>
            </small>
          </span>
        </div> */}
      </motion.div>

      {/* Footer Main Section */}
      <motion.div
        className="footer-main"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Logo */}
        <motion.div
          className="footer-logo"
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="/" aria-label="NewZeal Academy Home">
            <motion.img
              src={footerlogo}
              alt="NewZeal Academy Logo"
              loading="lazy"
              whileHover={{ scale: 1.05 }}
            />
          </a>
          <p style={{ width: "220px" }}>Are you a Passionate about teaching English? 
Partner with NewZeal Language Academy and inspire learners nationwide through online classes.. 
Contact us today! </p>
        </motion.div>

        {/* Links */}
        <div className="footer-links">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h4>Register</h4>
            <a href="/register-for-webinar">Register for Free Webinar</a>
            <a href="/enroll-for-course">Enroll to a Course</a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h4>Quick Links</h4>
             <a href="/">Home</a>
           
            <a href="/course">Courses</a>
            <a href="/career">Careers</a>
             <a href="/about">About Newzeal</a>
            <a href="/contact">Contact Us</a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h4>Legal</h4>
             <a href="/terms-and-conditions">Terms and Conditions</a>
            <a href="/privacy-policy">Privacy Policy</a>
             <a href="/refund-policy">Refund Policy</a>
          </motion.div>
        </div>

        {/* Contact */}
        <motion.div
          className="footer-contact"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h4>Newzeal Language Academy</h4>
          <p>
            <FaMapMarkerAlt /> 1st Block, Rajajinagar, Bengaluru - 560 010.
          </p>
          <p>
            <a href="mailto:info@newzealacademy.com">
              <FaEnvelope /> info@newzealacademy.com
            </a>
          </p>
          <p>
            <a href="tel:+919141007452">
              <FaPhone /> +91 63607 05213
            </a>
          </p>
          <div className="social-icons">
            <motion.a
              href="#"
              whileHover={{ scale: 1.2, color: "#3b5998" }}
              aria-label="Facebook"
            >
              <FaFacebookF />
            </motion.a>
            <motion.a
              href="#"
              whileHover={{ scale: 1.2, color: "#E1306C" }}
              aria-label="Instagram"
            >
              <FaInstagram />
            </motion.a>
            <motion.a
              href="#"
              whileHover={{ scale: 1.2, color: "#1DA1F2" }}
              aria-label="Twitter"
            >
              <FaTwitter />
            </motion.a>
            <motion.a
              href="#"
              whileHover={{ scale: 1.2, color: "#0077B5" }}
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </motion.a>
          </div>
        </motion.div>
      </motion.div>

      {/* Footer Bottom */}
      <motion.div
        className="footer-bottom"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <p>
          © 2025 <b>NewZeal Language Academy</b> | All rights reserved. Designed &
          Developed by{" "}
          <b>
            <a href="https://digiworq.com/" target="_blank" rel="noreferrer">
              DIGIWORQ
            </a>
          </b>
        </p>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
